<template>
  <PromptBar>
    <template #icon> <FriedIcon icon="info-circle" /></template>
    <template #title>{{ title }}</template>
    <template #description>
      {{ description }}
    </template>
    <template #button-container>
      <FriedButton
        data-external="signing-page-snackbar-review-button"
        :loading="loading"
        @click="$emit('click')"
      >
        {{ cta }}
      </FriedButton>
    </template>
  </PromptBar>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PromptBar from './PromptBar.vue';

export default defineComponent({
  components: {
    PromptBar,
  },
  props: {
    timeLeft: {
      type: Number,
      default: 20,
    },
    sender: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
    },
    isDsr: {
      type: Boolean,
    },
  },
  emits: ['click'],
  setup(props) {
    const { t } = useI18n();
    const title = computed(() =>
      props.isDsr
        ? t('dsr_updated_room_title', {
            SenderName: props.sender,
          })
        : `${props.sender} ${t('has-modified-the-document')}`
    );

    const secondsText = computed(() => (props.timeLeft === 1 ? t('second') : t('seconds')));

    const description = computed(() =>
      props.isDsr
        ? `${t('dsr_updated_room_description')} ${props.timeLeft} ${secondsText.value}`
        : `${t('the-document-will-automatically-update-in')} ${props.timeLeft} ${secondsText.value}`
    );

    const cta = computed(() => (props.isDsr ? t('dsr_update_button') : t('review-new-version')));

    return {
      title,
      secondsText,
      description,
      cta,
    };
  },
});
</script>
